import { render, staticRenderFns } from "./RemoveImage.vue?vue&type=template&id=610f4caf&"
import script from "@/scripts/modal/rentalService/removeImage.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/rentalService/removeImage.js?vue&type=script&lang=js&"
import style0 from "./RemoveImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports